<template>
    <el-dialog :title="title" :visible.sync="lookDialogVisible" :append-to-body="appendToBody" destroy-on-close>
        <iframe style="height: 80vh;" :src="lookUrl"></iframe>
    </el-dialog>
</template>
<script>
export default {
    props: {
        appendToBody: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
    },
    components: {},
    data() {
        return {
            token: localStorage.getItem('Authorization'),
            url: process.env.VUE_APP_SURVEY_H5_URL,
            lookDialogVisible: false,
            lookUrl: '',
        };
    },
    created() { },
    mounted() { },
    methods: {
        showDialog(id) {
            this.lookUrl = `${this.url}/h5/pages/feedbackTemplatePreview/index?id=${id}&token=${this.token}`
            console.log('this.lookUrl = ', this.lookUrl)
            this.lookDialogVisible = true
        },
    }
};
</script>
<style lang="less" scoped>
/deep/.el-dialog {
    width: fit-content;
}

/deep/.el-dialog__body {
    padding-top: 0 !important;
}
</style>
